export const START = "START";
export const WATER_TYPE = "WATER_TYPE";
export const WATER_SOURCE = "WATER_SOURCE";
export const INTENDED_APP = "INTENDED_APP";
export const IRRIGATION = "IRRIGATION";
export const GARDEN_TAPS = "GARDEN_TAPS";
export const HOME_SIZE = "HOME_SIZE";
export const TANK_GROUND = "TANK_GROUND";
export const SHOW_MORE = "SHOW_MORE";
export const IS_MAINS = "IS_MAINS"
export const QUESTION4 = "QUESTION4";
export const QUESTION5 = "QUESTION5";
export const QUESTION6 = "QUESTION6";
export const RESULT ='RESULT';
